<template>
  <BaseModal
    :id="`${moduleName}-${instanceId}`"
    class="popup"
    :show-on-desk="showOnDesk"
    :show-on-mobile="showOnMobile"
  >
    <div class="popup__wrapper">
      <IconClose
        color="#000000"
        title="Fechar"
        width="24"
        height="24"
      />
      <slot></slot>
    </div>
  </BaseModal>
</template>

<script>
import IconClose from '@/components/icons/IconClose.vue';
import BaseModal from './BaseModal.vue';

export default {
  name: 'Popup',
  components: {
    BaseModal,
    IconClose,
  },
  props: {
    ...BaseModal.props,
    triggerType: {
      type: String,
      default: '',
    },
    delayToShow: {
      type: [String, Number],
      default: '',
    },
    moduleName: {
      type: String,
      default: '',
    },
  },
  computed: {
    submittedStorageName() {
      return `lead-${this.instanceId}`;
    },
  },
  metadata: {
    extends: BaseModal.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'trigger',
            after: 'display',
            label: 'Acionamento',
            fields: [
              {
                name: 'triggerType',
                type: 'VueSelect',
                label: 'Tipo de acionamento',
                helpText:
                  'Por tempo: O pop-up irá aparecer após o tempo determinado.<br>Por intenção de saída: O pop-up irá aparecer na ação do usuário de sair da página.',
                default: 'delay',
                options: [
                  {
                    label: 'Por tempo',
                    value: 'delay',
                  },
                  {
                    label: 'Por intenção de saída',
                    value: 'exit-intent',
                  },
                ],
              },
              {
                name: 'delayToShow',
                type: 'Range',
                label: 'Tempo para exibição (em segundos)',
                min: 0,
                max: 60,
                step: 1,
                format: {
                  suffix: 's',
                },
                isEnabled({ triggerType }) {
                  return triggerType === 'delay';
                },
              },
            ],
          },
        ],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.popup {
  position: relative;
  background-color: rgba($lb-dark-gray, 0.4);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 12000;

  &__wrapper {
    position: relative;
    width: calc(100% - 20px);
    max-width: 500px;
    height: auto;
    // max-height: calc(100vh - 20px); não ativar no editor

    @include media-breakpoint-up(md) {
      max-width: 720px;
    }

    > i {
      position: absolute;
      top: 8px;
      right: 8px;
      padding: 8px;
      border-radius: 2px;
      background: $lb-white;
      cursor: pointer;
      z-index: 1;
    }
  }
}
</style>
